"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var React = require("react");
var Page_1 = require("../../Page");
var RenewalInviteMotorInvolvedObjectsTree_1 = require("./RenewalInviteMotorInvolvedObjectsTree");
var Types_1 = require("../../../Types");
var DocumentsTree_1 = require("../DocumentsTree");
var core_1 = require("@athena-portal/core");
var operators_1 = require("rxjs/operators");
var CommunicationsTree_1 = require("../CommunicationsTree");
var InteractionNotification_1 = require("../InteractionNotification");
var moment = require("moment");
var CompareInteractionsNotification_1 = require("../CompareInteractionsNotification");
var services_1 = require("@falcon/services");
var GenerateDocumentsAction_1 = require("../actions/GenerateDocumentsAction");
var CoverTierDisplay_1 = require("../../../components/CoverTierDisplay");
var ModelVersionComponent_1 = require("../../../components/ModelVersionComponent");
var RenewalInviteHomeInvolvedObjectsTree_1 = require("./RenewalInviteHomeInvolvedObjectsTree");
var RenewalCoveragesTree_1 = require("./RenewalCoveragesTree");
var commonFunctions_1 = require("../../../helpers/commonFunctions");
var RenewPolicyAction_1 = require("../actions/RenewPolicyAction");
var DirectDebitMandateInfoAction_1 = require("../actions/DirectDebitMandateInfoAction");
var DirectDebitPaymentInfoAction_1 = require("../actions/DirectDebitPaymentInfoAction");
var DirectDebitDelinquencyStatusAction_1 = require("../actions/DirectDebitDelinquencyStatusAction");
var DirectDebitBacsResponseAction_1 = require("../actions/DirectDebitBacsResponseAction");
var DataMappers_1 = require("../../../helpers/DataMappers");
var Tree_1 = require("../../../components/Tree");
var CoverLevelDisplay_1 = require("../../../components/CoverLevelDisplay");
var HomeOwnershipDisplay_1 = require("../../../components/HomeOwnershipDisplay");
var RenewalInviteTree = /** @class */ (function (_super) {
    __extends(RenewalInviteTree, _super);
    function RenewalInviteTree(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loaded: false,
            communicationsLoaded: false
        };
        return _this;
    }
    RenewalInviteTree.prototype.render = function () {
        var _this = this;
        if (this.props.interaction) {
            var startDate = this.props.interaction.headerInfo.startDate;
            var endDate = this.props.interaction.headerInfo.endDate;
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { onItemToggle: function () { return !_this.state.loaded && _this.getData(); }, label: "Renewal [".concat((0, commonFunctions_1.formatDate)(startDate), "] -> [").concat((0, commonFunctions_1.formatDate)(endDate), "]"), children: this.renderRenewalInviteTree() }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    RenewalInviteTree.prototype.renderRenewalInviteTree = function () {
        var renewalInviteTree = [];
        var totalAmount;
        var documents = this.getDocuments();
        if (this.props.interaction) {
            var createdOn = moment.utc(this.props.interaction.createdOn, moment.ISO_8601).format("DD/MM/YYYY, hh:mm");
            var coverTierChangeWording = (0, commonFunctions_1.getCoverTierChangeWording)(this.props.interaction);
            if (this.props.interaction.factors) {
                totalAmount = this.props.interaction.factors.annualPremium;
            }
            renewalInviteTree.push((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(CoverTierDisplay_1.CoverTierDisplay, { product: this.props.interaction.product, tier: this.props.interaction.coverTier }), services_1.productHelper.isHome(this.props.interaction) && (0, jsx_runtime_1.jsx)(CoverLevelDisplay_1.CoverLevelDisplay, { coverLevel: this.props.interaction.coverLevel }), services_1.productHelper.isHome(this.props.interaction) &&
                        (0, jsx_runtime_1.jsx)(HomeOwnershipDisplay_1.HomeOwnershipDisplay, { realEstate: this.props.interaction.realEstate[0] }), (0, jsx_runtime_1.jsx)(InteractionNotification_1.default, { interaction: this.props.interaction, customer: this.props.customerReferenceNumber }), (0, jsx_runtime_1.jsx)(CompareInteractionsNotification_1.default, { interaction: this.props.interaction }), totalAmount && (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Renewal price: ", (0, commonFunctions_1.getAmountToDisplay)(totalAmount)] }) }), coverTierChangeWording && (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)("div", { children: ["Renewal: ", coverTierChangeWording] }) }), (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Created on: ", createdOn] }) }), (0, jsx_runtime_1.jsx)(ModelVersionComponent_1.default, { interaction: this.props.interaction }), this.props.interaction.underwritingResult && this.props.interaction.underwritingResult.length > 0 &&
                        (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: "muli-bold-16", children: "Decline reasons:" }), " ", this.getUWResultObjects(this.props.interaction)] }) })] }, this.props.interaction.agreementNumber + "renewal details"));
            renewalInviteTree.push(this.getInvolvedObjectsTree());
            // Currently only implemented for home, no idea why this wasn't implemented for motor initially
            if (services_1.productHelper.isHome(this.props.interaction)) {
                renewalInviteTree.push((0, jsx_runtime_1.jsx)(RenewalCoveragesTree_1.RenewalCoveragesTree, { interaction: this.props.interaction }));
            }
            renewalInviteTree.push((0, jsx_runtime_1.jsx)(DocumentsTree_1.default, { documents: documents }, this.props.interaction.agreementNumber + "renewal documents tree"));
            renewalInviteTree.push(this.renderCommunicationsTree());
            renewalInviteTree.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Actions", children: this.renderActionsTree() }, this.props.interaction.agreementNumber + "renewal actions tree"));
        }
        return renewalInviteTree;
    };
    ;
    RenewalInviteTree.prototype.renderActionsTree = function () {
        var _a, _b;
        var actions = [];
        var documents = this.getDocuments();
        var communications = this.getCommunications();
        if (services_1.productHelper.isWolfMotor(this.props.interaction) || services_1.productHelper.isHome(this.props.interaction)) {
            actions.push((0, jsx_runtime_1.jsx)(GenerateDocumentsAction_1.default, { policyNumber: this.props.interaction.agreementNumber, interactionId: this.props.interaction._id, policyStatus: this.props.interaction.status, policyProduct: this.props.interaction.product, documents: documents, communications: communications, userReference: this.props.customerReferenceNumber }, "Generate documents action"));
            this.directDebitActions(actions);
            var inGracePeriod = moment().isAfter(moment((_b = (_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.headerInfo) === null || _b === void 0 ? void 0 : _b.startDate));
            if (inGracePeriod) {
                actions.push((0, jsx_runtime_1.jsx)(RenewPolicyAction_1.default, { policyNumber: this.props.interaction.agreementNumber, customerReferenceNumber: this.props.customerReferenceNumber }));
            }
        }
        return actions;
    };
    RenewalInviteTree.prototype.getDocuments = function () {
        var documents = [];
        if (this.state.renewalDocuments) {
            documents.push.apply(documents, this.state.renewalDocuments);
        }
        return (0, DataMappers_1.mapDocumentTitles)(documents);
    };
    RenewalInviteTree.prototype.getCommunications = function () {
        var communications = [];
        if (this.state.renewalCommunications) {
            communications.push.apply(communications, this.state.renewalCommunications);
        }
        return (0, DataMappers_1.mapCommunicationTitles)(communications);
    };
    RenewalInviteTree.prototype.renderCommunicationsTree = function () {
        if (this.state.communicationsLoaded) {
            var communications = this.getCommunications();
            return ((0, jsx_runtime_1.jsx)(CommunicationsTree_1.default, { communications: communications, policyNumber: this.props.interaction.agreementNumber, policyVersionNumber: this.props.interaction.agreementVersion, process: this.props.interaction.process, interactionId: this.props.interaction._id }, this.props.interaction.agreementNumber + "renewal communications tree"));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    RenewalInviteTree.prototype.getInvolvedObjectsTree = function () {
        if (services_1.productHelper.isWolfMotor(this.props.interaction)) {
            return ((0, jsx_runtime_1.jsx)(RenewalInviteMotorInvolvedObjectsTree_1.default, { interaction: this.props.interaction }, this.props.interaction.agreementNumber + "renewal objects tree"));
        }
        else if (services_1.productHelper.isHome(this.props.interaction)) {
            return ((0, jsx_runtime_1.jsx)(RenewalInviteHomeInvolvedObjectsTree_1.RenewalInviteHomeInvolvedObjectsTree, { interaction: this.props.interaction }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    RenewalInviteTree.prototype.getUWResultObjects = function (interaction) {
        var uwElements = [];
        for (var _i = 0, _a = interaction.underwritingResult; _i < _a.length; _i++) {
            var uw = _a[_i];
            uwElements.push((0, jsx_runtime_1.jsxs)("div", { children: [uw.objectName, ", ", uw.message] }));
        }
        return uwElements;
    };
    RenewalInviteTree.prototype.getData = function () {
        var _this = this;
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getRenewalDocuments(_this.props.interaction.agreementNumber, _this.props.interaction.agreementVersion)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (renewalDocuments) {
                _this.setState({ renewalDocuments: renewalDocuments });
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getRenewalCommunications(_this.props.interaction.agreementNumber, _this.props.interaction.agreementVersion)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (renewalCommunications) {
                _this.setState({ renewalCommunications: renewalCommunications, communicationsLoaded: true });
            });
        });
        this.setState({
            loaded: true
        });
    };
    RenewalInviteTree.prototype.directDebitActions = function (actions) {
        if (services_1.productHelper.isDirectDebit(this.props.interaction)) {
            actions.push((0, jsx_runtime_1.jsx)(DirectDebitMandateInfoAction_1.default, { customerReferenceNumber: this.props.customerReferenceNumber, policyNumber: this.props.interaction.agreementNumber }, "Direct debit mandate info action"));
            actions.push((0, jsx_runtime_1.jsx)(DirectDebitPaymentInfoAction_1.default, { customerReferenceNumber: this.props.customerReferenceNumber, policyNumber: this.props.interaction.agreementNumber }, "Direct debit payment info action"));
            actions.push((0, jsx_runtime_1.jsx)(DirectDebitDelinquencyStatusAction_1.default, { customerReferenceNumber: this.props.customerReferenceNumber, policyNumber: this.props.interaction.agreementNumber }, "Direct debit delinquency status action"));
            actions.push((0, jsx_runtime_1.jsx)(DirectDebitBacsResponseAction_1.default, { customerReferenceNumber: this.props.customerReferenceNumber, policyNumber: this.props.interaction.agreementNumber }, "Direct debit BACS response action"));
        }
    };
    RenewalInviteTree.contextType = Page_1.PageContext;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], RenewalInviteTree.prototype, "supportPortalService", void 0);
    RenewalInviteTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], RenewalInviteTree);
    return RenewalInviteTree;
}(React.Component));
exports.default = RenewalInviteTree;
//# sourceMappingURL=RenewalInviteTree.js.map